// removed by extract-text-webpack-plugin
module.exports = {"body":"_346Ad_3CO8nPLqK3sghVd6"};


//////////////////
// WEBPACK FOOTER
// ./components/Activity.module.css
// module id = 2333
// module chunks = 1